import React from 'react';
import "./hero.css"
import Header from '../Header/Header';
import hero_img from "../../img/hero_image.png";
import hero_img_back from "../../img/hero_image_back.png";
import heart from "../../img/heart.png";
import calories from "../../img/calories.png";
import {motion} from 'framer-motion';
import numcounter from "number-counter"; 

const Hero = () => {
  const transition = {type: 'spring', duration : 3};
  const mobile =window.innerWidth<=768 ? true: false;
  return (
    <>
      <div className='hero' id='home'>
      <div className="blur blur-h"></div>
        <div className="left-h">
          <Header/>

          {/* the best ad */}
          <div className="the-best-ad">
            <motion.div
            initial= {{left: mobile? "165px": "238px"}}
            whileInView={{left: '8px'}}
            transition={{...transition, type: 'tween'}}></motion.div>
            <span>the best fitness club in the town</span>
          </div>

          {/* hero heading */}

          <div className="hero-text">
            <div>
              <span className='stroke-text'>Shape</span>
              <span>Your</span>
            </div>
            <div>
              <span>Ideal body</span>
            </div>
            <div>
              <span>In here we will help you to shape and build your ideal body and live up your life to fullest</span>
            </div>
          </div>

          {/* figures */}

          <div className="figures">
            <div>
                 <span>
                  <numcounter end={140} start={100} delay='4' preFix="+"/>
                 </span>
                 <span>expert coaches</span>
            </div>
            <div>
                 <span>+978</span>
                 <span>members joined</span>
            </div>
            <div>
                 <span>+50</span>
                 <span>fitness programs</span>
            </div>
          </div>

          {/* hero button */}

          <div className="hero-buttons">
            <buttons className='btn btn1'>Get Started</buttons>
            <buttons className='btn btn2'>Learn More</buttons>
          </div>
        </div>
        <div className="right-h">
          <button className='btn'>Join Now</button>

          <motion.div 
            initial= {{right: '-1rem'}}
            whileInView={{right: '4rem'}}
            transition={transition} 
            className="heart-rate">
            <img src={heart} alt="heart" />
            <span>Heart Rate</span>
            <span className='t-white'>116 bpm</span>
          </motion.div>
          <img src= {hero_img} alt="img" className='hero-image' />
          <motion.img 
          initial= {{right: '11rem'}}
          whileInView={{right: '20rem'}}
          transition={transition} 
          src= {hero_img_back} alt="img" className='hero-image-back' />

          {/* calories */}

          <motion.div 
          initial= {{right: '37rem'}}
          whileInView={{right: '28rem'}}
          transition={transition} 
          className="calories">
            <img src={calories} alt="img" />
            <div>
            <span className='t-gray'>Calories Burned</span>
            <span className='t-white'> 220 kcal</span>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
}

export default Hero;
